module.exports = __webpack_public_path__ + "img/ppt.a117bc7b.png";